module.exports = __webpack_public_path__ + "media/乐享简介.5dc4438c.mp4";